<template>
    <div  class="middleBox "> 
        <h4 class="title pb-3 border-bottom text-left mb-4">{{$t('financialDetail')}}</h4>
        <!--loader - message--->
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
        <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        <div class="pt-2">
            <div class="stepForm"> 
                <div class="row">
					<div class="col-12 mobPad">
                        <h5 class="subtitle mb-3">{{$t('acOpeningReason')}}</h5>
                        <div class="form-group flex-wrap d-flex justify-content-start align-items-center field-wrapper mb-3">  
                            <div class="customUserType multiSlct mb-2 mr-2"  v-for="(list,key) in acOpeningReason" :class="(ac_opening_reason == key)?'selected' :''"   >
                                <label class="customRadio-button border"> 
									{{$t(list)}}
									<input type="radio" name="ac_opening_reason" v-model="ac_opening_reason" :value="key" :disabled="disable" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has(ac_opening_reason) }" ref="ac_opening_reasonInput" @focus="trackFzEvent('Purpose')">
									<span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="clearfix"></div>
                            <p class="error w-100" v-if="submitted && errors.first('ac_opening_reason')">{{$t('acOpeningStatusFieldReq')}}</p>
                        </div>
                    </div> 
                    <div class="col-12 mobPad">
                        <h5 class="subtitle mb-3">{{$t('empStatus')}}</h5>
                        <div class="form-group flex-wrap d-flex justify-content-start align-items-center field-wrapper mb-3">  
                            <div class="customUserType multiSlct mb-2 mr-2"  v-for="(eList,key) in empStatus" :class="(emp_status == key)?'selected' :''"   >
                                <label class="customRadio-button border"> 
									{{$t(eList)}} 
									<input type="radio" name="emp_status" v-model="emp_status" :value="key" :disabled="disable" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has(emp_status) }" ref="emp_statusInput" @focus="trackFzEvent('Employment')">
									<span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="clearfix"></div>
                            <p class="error w-100" v-if="submitted && errors.first('emp_status')">{{$t('empStatusFieldReq')}}</p>
                        </div>
                    </div> 
                    <div class="col-12 mobPad" v-if="![3,4].includes(parseInt(emp_status))">
                        <!-- <div class="form-group field-wrapper">
                            <input placeholder="" type="text" v-model="other_employed" class="float-field form-control" v-validate="'required'" name="other_employed"  :class="{ 'is-invalid': errors.has('other_employed') }" ref="other_employedInput"  :disabled="disable"/>
                            <label class="float-label">If other please specify<sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('other_employed')">{{ error }}</p>  
                        </div> -->
                        <div class="form-group field-wrapper">
                            <input placeholder=" " type="text" v-model="position" class="float-field form-control" v-validate="'required'" name="position"  :class="{ 'is-invalid': errors.has('position') }" :disabled="disable" ref="positionInput"/>
                            <label for="position" class="float-label">{{$t('position')}}<sup class="red">*</sup></label>
                            <p class="error" v-if="submitted && errors.first('position')">{{$t('fieldReq1')}}</p>  
                        </div>
                        <div class="form-group field-wrapper">
                            <input placeholder=" " type="text" v-model="emp_name"  v-validate="'required'" name="emp_name" class="float-field form-control"  :class="{ 'is-invalid': errors.has('emp_name') }" :disabled="disable" ref="emp_nameInput"/>
                            <label for="emp_name" class="float-label">{{$t('emp_name')}}<sup class="red">*</sup></label>
                            <p class="error" v-if="submitted && errors.first('emp_name')">{{$t('fieldReq1')}}</p>  
                        </div>
                        <div class="form-group">
                            <h5 class="subtitle mb-3">{{$t('busActQues')}}</h5>
                            <div class="form-group d-flex flex-wrap justify-content-start align-items-center field-wrapper mb-3"> 
                                <select class="customflaotField form-control pt-0" v-model="occupation" v-validate="'required'" name="occupation" :class="{ 'is-invalid': errors.has('occupation') }" :disabled="disable" ref="occupationInput" @change="trackFzEvent('BActivity')">
                                    <option value="">Please Select...</option>
                                    <option v-for="(oList,key) in occupationList" :class="(occupation == key)?'selected' :''" :value="key">{{$t(oList)}} </option>
                                </select>
                                <p class="error w-100" v-if="submitted && errors.first('occupation')">{{$t('fieldReq1')}}</p>
                            </div>
                        </div>
                    </div>
					<!-- <div class="col-12 mobPad">
						<h5 class="subtitle mb-3">{{$t('busActQues')}}</h5>
						<div class="form-group d-flex flex-wrap justify-content-start align-items-center field-wrapper mb-3"> 
							<select class="customflaotField form-control" v-model="occupation" v-validate="'required'" name="occupation" :class="{ 'is-invalid': errors.has('occupation') }" :disabled="disable">
								<option value="">Please Select...</option>
								<option v-for="(oList,key) in occupationList" :class="(occupation == key)?'selected' :''" :value="key">{{$t(oList)}} </option>
							</select>
							<p class="error w-100" v-if="submitted && errors.first('occupation')">{{$t('fieldReq')}}</p>
						</div>
					</div> -->
                    <div class="col-12 mobPad">
						<h5 class="subtitle mb-3">{{$t('Education')}}</h5>
						<div class="form-group d-flex flex-wrap justify-content-start align-items-center field-wrapper mb-3"> 
							<select class="customflaotField form-control pt-0" v-model="education" v-validate="'required'" name="education" :class="{ 'is-invalid': errors.has('education') }" :disabled="disable" ref="educationInput"  @change="trackFzEvent('Education')">
								<option value="">Please Select...</option>
								<option v-for="(oList,key) in educationList" :class="(education == key)?'selected' :''" :value="key">{{$t(oList)}} </option>
							</select>
							<p class="error w-100" v-if="submitted && errors.first('education')">{{$t('fieldReq')}}</p>
						</div>
					</div>
                    <div class="col-12 mobPad">
                        <h5 class="subtitle mb-3">{{$t('estYearlyIncome')}}</h5>
                        <div class="form-group d-flex flex-wrap justify-content-start align-items-center field-wrapper mb-3">  
                            <div class="customUserType multiSlct  mb-2 mr-2" v-for="(yList,key) in estYearlyIncome" :class="(yearly_income == key)?'selected' :''">
                                <label class="customRadio-button border"> 
									{{$t(yList)}}
									<input type="radio" name="yearly_income" v-model="yearly_income" :value="key" :disabled="disable" v-validate="'required'"     :class="{ 'is-invalid': submitted && errors.has(yearly_income) }" ref="yearly_incomeInput" @focus="trackFzEvent('Income')">
									<span class="checkmark"></span>
                                </label>
                            </div> 
                            <div class="clearfix"></div>
							<p class="error w-100" v-if="submitted && errors.first('yearly_income')">{{$t('yearEncFieldReq')}}.</p>  
                        </div>
                        
                    </div> 
                    <div class="col-12 mobPad">
                        <h5 class="subtitle mb-3">{{$t('estNetWorth')}}</h5>
                        <div class="form-group d-flex flex-wrap justify-content-start align-items-center field-wrapper mb-3">  
                            <div class="customUserType multiSlct mb-2 mr-2"  v-for="(nList,key) in estNetWorth" :class="(net_worth == key)?'selected' :''">
                                <label class="customRadio-button border"> 
									{{$t(nList)}}
									<input type="radio" name="net_worth" v-model="net_worth" :value="key" :disabled="disable" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has(net_worth) }" ref="net_worthInput" @focus="trackFzEvent('Networth')">
									<span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="clearfix"></div>                            
							<p class="error w-100" v-if="submitted && errors.first('net_worth')">{{$t('netWorthFieldReq')}}.</p>
                        </div>
                    </div> 
                    <div class="col-12 mobPad">
                        <h5 class="subtitle mb-3">{{$t('netDisposableIncome')}}</h5>
                        <div class="form-group d-flex flex-wrap justify-content-start align-items-center field-wrapper mb-3">  
                            <div class="customUserType multiSlct mb-2 mr-2"  v-for="(nList,key) in netDisposableIncome" :class="(net_disposable_income == key)?'selected' :''">
                                <label class="customRadio-button border"> 
									{{$t(nList)}}
									<input type="radio" name="Net_Dispoasble_Income" v-model="net_disposable_income" :value="key" :disabled="disable" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has(Net_Dispoasble_Income) }" ref="net_disposable_incomeInput" @focus="trackFzEvent('NetIncome')" />
									<span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="clearfix"></div>                            
							<p class="error w-100" v-if="submitted && errors.first('Net_Dispoasble_Income')">{{$t('disposableReq')}}.</p>
                        </div>
                    </div> 
                    <div class="col-12 mobPad">
                        <h5 class="subtitle mb-3">{{$t('investedTradingAmount')}}<span class="text-danger">*</span></h5>
                        <div class="form-group d-flex flex-wrap justify-content-start align-items-center field-wrapper mb-3">  
                            <div class="customUserType multiSlct mb-2 mr-2"  v-for="(nList,key) in investedTradingAmount" :class="(invested_trading_amount == key)?'selected' :''">
                                <label class="customRadio-button border"> 
									{{$t(nList)}}
									<input type="radio" name="invested_trading_amount" v-model="invested_trading_amount" :value="key" :disabled="disable" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has(invested_trading_amount) }" ref="invested_trading_amountInput"
                                    @focus="trackFzEvent('InvestAmount')">
									<span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="clearfix"></div>                            
							<p class="error w-100" v-if="submitted && errors.first('invested_trading_amount')">{{$t('investedAmount')}}.</p>
                        </div>
                    </div> 
                    <div class="col-12 mobPad">
                        <h5 class="subtitle mb-3">{{$t('tradingTurnover')}}<span class="text-danger">*</span></h5>
                        <div class="form-group d-flex flex-wrap justify-content-start align-items-center field-wrapper mb-3">  
                            <div class="customUserType multiSlct mb-2 mr-2"  v-for="(nList,key) in tradingTurnover" :class="(trading_turnover == key)?'selected' :''">
                                <label class="customRadio-button border"> 
									{{$t(nList)}}
									<input type="radio" name="trading_turnover" v-model="trading_turnover" :value="key" :disabled="disable" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has(trading_turnover) }" ref="trading_turnoverInput" @focus="trackFzEvent('Turnover')">
									<span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="clearfix"></div>                            
							<p class="error w-100" v-if="submitted && errors.first('trading_turnover')">{{$t('tradingTurenOver')}}.</p>
                        </div>
                    </div>
                    <!-- <div class="col-12 mobPad">
                        <h5 class="subtitle mb-3">{{$t('accountTurnover')}}</h5>
                        <div class="form-group d-flex flex-wrap justify-content-start align-items-center field-wrapper mb-3 mobBottom-margin">  
                            <div class="customUserType multiSlct mb-2 mr-2" v-for="(aList,key) in antAccountTurnover" :class="(account_turnover == key)?'selected' :''">
                                <label class="customRadio-button border"> 
									{{$t(aList)}}
									<input type="radio" name="account_turnover" v-model="account_turnover" :value="key" :disabled="disable" v-validate="'required'"     :class="{ 'is-invalid': submitted && errors.has(account_turnover) }" ref="account_turnoverInput">
									<span class="checkmark"></span>
                                </label>
                            </div> 
                            <div class="clearfix"></div>
                            <p class="error w-100" v-if="submitted && errors.first('account_turnover')">{{$t('accTurnFieldReq')}}</p>
                        </div>
                    </div> -->
					<div class="col-12 mobPad">
                        <h5 class="subtitle mb-3">{{$t('sourceOfFunds')}}<span class="text-danger">*</span></h5>
                        <div class="form-group flex-wrap d-flex justify-content-start align-items-center field-wrapper mb-3">  
                            <div class="customUserType multiSlct mb-2 mr-2"  v-for="(list,key) in sourceOfFunds" :class="(source_of_fund == key)?'selected' :''"   >
                                <label class="customRadio-button border"> 
									{{$t(list)}}
									<input type="radio" v-model="source_of_fund" :value="key"  name="source_of_fund" v-validate="'required'" :disabled="disable"  :class="{ 'is-invalid': submitted && errors.has(source_of_fund) }" ref="source_of_fundInput" @change="employment = '';other_employed = ''" @focus="trackFzEvent('FundSource')">
									<span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="clearfix"></div>
                            <!-- <input type="hidden" name="source_of_fund" v-validate="'required'" v-if="source_of_fund"> -->
                            <p class="error w-100" v-if="submitted && errors.first('source_of_fund')">{{$t('sourceOfFundStatus')}}.</p>
                        </div>
                    </div>
                    <!-- <div class="col-12 mobPad" v-if="parseInt(source_of_fund) == 1">
						<h5 class="subtitle mb-3">If employed please specify</h5>
						<div class="form-group d-flex flex-wrap justify-content-start align-items-center field-wrapper mb-3"> 
							<select class="customflaotField form-control" v-model="employment" v-validate="'required'" name="employment" :class="{ 'is-invalid': errors.has('employment') }" :disabled="disable">
								<option value="">Please Select...</option>
								<option v-for="(eList,key) in employmentList" :class="(employment == parseInt(key))?'selected' :''" :value="parseInt(key)">{{eList}} </option>
							</select>
							<p class="error w-100" v-if="submitted && errors.first('employment')">{{$t('fieldReq')}}</p>
						</div>
					</div> -->
                    <div class="col-12 mobPad" v-if="parseInt(source_of_fund) == 8">
                        <div class="form-group field-wrapper">
                            <input placeholder="" type="text" v-model="other_employed" class="float-field form-control" v-validate="'required'" name="other_employed"  :class="{ 'is-invalid': errors.has('other_employed') }" ref="other_employedInput"  :disabled="disable"/>
                            <label class="float-label">If other please specify<sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('other_employed')">{{ error }}</p>  
                        </div>
                    </div>
					<div class="col-12 mobPad">
                        <h5 class="subtitle mb-3">{{$t('natureOfTransaction')}}<span class="text-danger">*</span></h5>
                        <div class="form-group flex-wrap d-flex justify-content-start align-items-center field-wrapper mb-3">  
                            <div class="customUserType multiSlct mb-2 mr-2"  v-for="(list,key) in natureOfTransaction" :class="(nature_of_transaction == key)?'selected' :''"   >
                                <label class="customRadio-button border"> 
									{{$t(list)}} 
									<input type="radio" name="nature_of_transaction" v-model="nature_of_transaction" :value="key" :disabled="disable" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has(nature_of_transaction) }" ref="nature_of_transactionInput" @focus="trackFzEvent('TNature')">
									<span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="clearfix"></div>
                            <p class="error w-100" v-if="submitted && errors.first('nature_of_transaction')">{{$t('natureOfTransactionStatus')}}.</p>
                        </div>
                    </div> 
					<div class="col-12 mobPad">
                        <h5 class="subtitle mb-3">{{$t('originOfFunds')}}<span class="text-danger">*</span></h5>
                        <div class="form-group flex-wrap d-flex justify-content-start align-items-center field-wrapper mb-3">  
							<div class="customUserType multiSlct mb-2 mr-2"  v-for="(list,key) in originOfFunds" :class="(origin_of_funds == key)?'selected' :''"   >
                                <label class="customRadio-button border"> 
									{{$t(list)}} 
									<input type="radio" name="origin_of_funds" v-model="origin_of_funds" :value="key" :disabled="disable" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has(origin_of_funds) }" ref="origin_of_fundsInput" @focus="trackFzEvent('FundOrigin')">
									<span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="clearfix"></div>
                            <p class="error w-100" v-if="submitted && errors.first('origin_of_funds')">{{$t('sourceOfFundStatus')}}.</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 mobPad">
                    <div class="full-width border-top pt-3 submitButton align-items-center d-flex spacebetween mt-3 w-100">
                        <div class="leftbtn text-center">
                            <a class="d-block mx-auto" href="#"  v-on:click="doitLaterEvent" >{{$t('iDoLater')}}</a>
                        </div> 
                        <button class="prism_btn btn_sm" v-on:click="submit()">{{$t('saveContinue')}}</button>
                        <!-- <button class="prism_btn btn_sm" @click="showTabFunc('warning')">Open</button> -->
                    </div>
                </div>                 
            </div>
        </div>
        <appWarningsNotice v-if="showTab == 'warning'" class="warning-notice"></appWarningsNotice>
    </div>
</template>
<script>
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    import { fxViewMixins } from '@/plugins/fxView'
    import warningsNotice from "../shared/warnings-notice";
    export default {
        name: 'stepTwo',
        mixins: [fxViewMixins],
        data() {
            return {
                showTab: '',
                submittedRequest: '',
                "emp_status" : '',
                "occupation" : '',
                "education": '',
                "employment": '',
                "yearly_income" : '',
                "net_worth" : '',
                net_disposable_income: '',
                invested_trading_amount: '',
                trading_turnover: '',
				"ac_opening_reason": '',
				"source_of_fund": '',
				"nature_of_transaction": '',
				"origin_of_funds": '',
                "other_employed": '',
                "step" : 2,
                position: '',
                emp_name: '',
                submitted: false,
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                disable: false,
                Net_Dispoasble_Income: '',
            }
        },
        props: ["show_tab"],
        
        methods:{
            showTabFunc(getData) {
                if (this.showTab == getData) {
                    this.showTab = "";
                    this.$parent.show_tab = "";
                } else {
                    this.showTab = getData;
                    this.$parent.show_tab = getData;
                }
            },
            closeModalFunc(){
                this.$parent.$parent.showStepComponent = false
            },
            ...mapActions({
                _runRegisterStepTwo: types.RUN_REGISTER_STEP2
            }),
            submit(){
                
                if(this.disable){
                    let currentStep = this.get_user.step

                    if('tempStep' in this.get_user && currentStep < this.get_user.tempStep){
                        currentStep = this.get_user.tempStep
                    }
                    this.get_user.tempStep = currentStep
                    this.get_user.step = 2         
                    let user_json = this.get_user
                    this.$store.commit(types.SET_STATE, user_json)
                }else{
                    const _that = this
                    _that.submitted = true;
                    _that.$validator.validate().then(valid => {
                        if (valid) {
                            let input_json={
                                'globalParams' :{
                                    'emp_status' : _that.emp_status,
                                    'occupation' : _that.occupation,
                                    'yearly_income' : _that.yearly_income,
                                    'net_worth' : _that.net_worth,
                                    'account_turnover' : _that.trading_turnover,
									'ac_opening_reason': _that.ac_opening_reason,
                                    'nature_of_transaction': _that.nature_of_transaction,
                                    'source_of_fund': _that.source_of_fund,
                                    'source_of_fund_other':(_that.source_of_fund == 8 ?_that.other_employed:_that.source_of_fund == 1?_that.employment:''),
									'origin_of_funds': _that.origin_of_funds,
                                    'step' : _that.step,
                                    'position': _that.position,
                                    'emp_name': _that.emp_name,
                                    'education': _that.education,
                                    'net_disposable_income': _that.net_disposable_income,
                                    'invested_trading_amount': _that.invested_trading_amount,
                                    // 'trading_turnover': _that.trading_turnover,
                                },
                                'localParams' :{
                                    "parameter" : _that
                                }
                            }
                            this.$trackEvent('CP+Client+Verification+3+Next')
                            this.$trackEvent('CP+Client+Verification+4+Pageview')
                            _that._runRegisterStepTwo(input_json)

                        }else{
                            _that.handleValidationErrorAdvanced(_that.errors)
                        }
                    });
                }
            },
            trackFzEvent(eventName){
				switch(eventName){
					case 'Purpose': 
						this.$trackEvent('CP+Client+Verification+3+Purpose');
					break;
					case 'Employment':
						this.$trackEvent('CP+Client+Verification+3+Employment');
					break;
					case 'BActivity':
						this.$trackEvent('CP+Client+Verification+3+Business+Activity');
					break;
					case 'Education':
                        this.$trackEvent('CP+Client+Verification+3+Business+Education');
					break;
					case 'Income':
                        this.$trackEvent('CP+Client+Verification+3+Income');
					break;
					case 'Networth':
                        this.$trackEvent('CP+Client+Verification+3+Net+Worth');
					break;
					case 'NetIncome':
                        this.$trackEvent('CP+Client+Verification+3+Net+Income');
					break;
					case 'InvestAmount':
                        this.$trackEvent('CP+Client+Verification+3+Invest+Amount');
					break;
					case 'Turnover':
                        this.$trackEvent('CP+Client+Verification+3+Turnover');
					break;
					case 'FundSource':
						this.$trackEvent('CP+Client+Verification+3+Fund+Source');
					break;
					case 'TNature':
                        this.$trackEvent('CP+Client+Verification+3+Transaction+Nature');
					break;
					case 'FundOrigin':
                        this.$trackEvent('CP+Client+Verification+3+Fund+Origin');
					break;
					
				}
			},
            doitLaterEvent(){
				this.$trackEvent('CP+Client+Verification+3+Later');
				this.$parent.do_later = true
			}
        },
        created(){
            this.$trackEvent('CP+Client+Verification+3+Pageview')
            if(parseInt(this.get_user.profile.ipv_status)){
                this.disable = true;
            }
            this._runGetUserRegisterationStepData({'globalParams' :{},'localParams' :{ "parameter" : this , "step" : '2'}})
        },
        components: {
            appWarningsNotice: warningsNotice,
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/registerSteps/step2.vue